<template>
  <div v-loading="listWrapLoading" class="orderlist">
    <el-tabs is-dot :value="10" class="orderlist-tabs orderlist-tabs-status" v-model="status1" @tab-click="topTabsStatus">
      <el-tab-pane label="全部" name="0">
      </el-tab-pane>
      <el-tab-pane label="待付款" name="1">
        <span slot="label">
          <el-badge class="header-icon-msg-item" :max="99" v-if="reddot.countOrderToPay" :value="reddot.countOrderToPay">待付款</el-badge>
          <span v-else>待付款</span>
        </span>
      </el-tab-pane>
      <el-tab-pane label="待发货" name="2">
        <span slot="label">
          <el-badge class="header-icon-msg-item" :max="99" v-if="reddot.countOrderToDelivery" :value="reddot.countOrderToDelivery">待发货</el-badge>
          <span v-else>待发货</span>
        </span>
      </el-tab-pane>
      <el-tab-pane label="待收货" name="3">
        <span slot="label">
          <el-badge class="header-icon-msg-item" :max="99" v-if="reddot.countOrderToDeliveried" :value="reddot.countOrderToDeliveried">待收货</el-badge>
          <span v-else>待收货</span>
        </span>
      </el-tab-pane>
      <el-tab-pane label="退款中" name="4">
        <span slot="label">
          <el-badge class="header-icon-msg-item" :max="99" v-if="reddot.countOrderToRefunding" :value="reddot.countOrderToRefunding">退款中</el-badge>
          <span v-else>退款中</span>
        </span>
      </el-tab-pane>
      <!-- <el-tab-pane label="已签收" name="5">
        <span slot="label">
          <el-badge class="header-icon-msg-item" :max="99">已签收</el-badge>
        </span>
      </el-tab-pane> -->
      <el-tab-pane label="交易完成" name="6"></el-tab-pane>
      <el-tab-pane label="交易关闭" name="7"></el-tab-pane>
    </el-tabs>
    <el-row align class="list-top-types">订单类型：
      <el-tabs is-dot :value="10" class="orderlist-tabs  orderlist-tabs-types" v-model="searchParams.type" @tab-click="changeType">
        <el-tab-pane label="全部" name="00"></el-tab-pane>
        <el-tab-pane label="普通" name="1">
          <span slot="label">
            <!-- <el-badge class="header-icon-msg-item" :max="99" v-if="reddot.normalOrder" :value="reddot.normalOrder">普通</el-badge> -->
            <el-badge class="header-icon-msg-item" :max="99" v-if="reddot.normalOrder">普通</el-badge>
            <span v-else>普通</span>
          </span>
        </el-tab-pane>
        <el-tab-pane label="秒杀" name="2">
          <span slot="label">
            <!-- <el-badge class="header-icon-msg-item" :max="99" v-if="reddot.seckilOrder" :value="reddot.seckilOrder">秒杀</el-badge> -->
            <el-badge class="header-icon-msg-item" :max="99" v-if="reddot.seckilOrder">秒杀</el-badge>
            <span v-else>秒杀</span>
          </span>
        </el-tab-pane>
        <el-tab-pane label="优惠券" name="3">
          <span slot="label">
            <!-- <el-badge class="header-icon-msg-item" :max="99" v-if="reddot.couponOrder" :value="reddot.couponOrder">优惠券</el-badge> -->
            <el-badge class="header-icon-msg-item" :max="99" v-if="reddot.couponOrder">优惠券</el-badge>
            <span v-else>优惠券</span>
          </span>
        </el-tab-pane>
        <el-tab-pane label="助力" name="4">
          <span slot="label">
            <!-- <el-badge class="header-icon-msg-item" :max="99" v-if="reddot.helpOrder" :value="reddot.helpOrder">助力</el-badge> -->
            <el-badge class="header-icon-msg-item" :max="99" v-if="reddot.helpOrder">助力</el-badge>
            <span v-else>助力</span>
          </span>
        </el-tab-pane>
        <el-tab-pane label="砍价" name="5">
          <span slot="label">
            <!-- <el-badge class="header-icon-msg-item" :max="99" v-if="reddot.barginOrder" :value="reddot.barginOrder">砍价</el-badge> -->
            <el-badge class="header-icon-msg-item" :max="99" v-if="reddot.barginOrder">砍价</el-badge>
            <span v-else>砍价</span>
          </span>
        </el-tab-pane>
        <el-tab-pane label="拼团" name="6">
          <span slot="label">
            <!-- <el-badge class="header-icon-msg-item" :max="99" v-if="reddot.collageOrder" :value="reddot.collageOrder">拼团</el-badge> -->
            <el-badge class="header-icon-msg-item" :max="99" v-if="reddot.collageOrder">拼团</el-badge>
            <span v-else>拼团</span>
          </span>
        </el-tab-pane>
        <el-tab-pane label="其他" name="0">
          <span slot="label">
            <el-badge class="header-icon-msg-item" :max="99">其他</el-badge>
          </span>
        </el-tab-pane>
      </el-tabs>
    </el-row>
    <orderlist v-if="listShow" :key="updataChild" :showSelect="true" :dataList="dataList" :pagination="pagination" :searchParams="searchParams"></orderlist>
  </div>
</template>
<script>
import orderlist from "@/components/list/orderlist.vue";
export default {
  data () {
    return {
      listWrapLoading: true,
      listShow: true,
      updataChild: "",
      dataList: { data: [], topCon: true, tableTopCon: true, pagi: true },
      start_time: "",
      end_time: "",
      //搜索下拉
      search_type: "0",
      search_value: "",
      //排序类型 0为订单号 1为下单时间 2为商品数 3为订单金额 4为支付金额
      order_type: "0",
      //倒序desc 顺序asc
      sort_order: "asc",
      reddot: "",

      //搜索参数
      searchParams: {
        status: "0",
        type: "00"
      },
      pagination: {}
    };
  },
  created () {
    // console.log(localStorage.getItem("orderReddot"));
    this.searchParams.status = this.status1;
    this.reddot = JSON.parse(localStorage.getItem("orderReddot"));
    //默认打开订单列表的初始数据是按下单时间倒序
    this.getData({ status: this.status1, order_type: "1", sort_order: "desc" });
  },
  computed: {
    //列表状态
    status1: {
      get: function () {
        return this.getSliderStatus(this.$store.state._status);
      },
      set: function () { }
    }

  },
  methods: {
    //订单状态点击
    topTabsStatus (row) {
      this.$store.dispatch('changeCurrentTab', row.label)
      this.searchParams.status = row.name;
      this.searchParams.type = "00";
      if (this.searchParams.type == "00") {
        this.getData({ status: row.name });
      } else {
        this.getData({
          status: row.name,
          type: this.searchParams.type
        });
      }
    },
    //点击订单类型按钮
    changeType (row) {
      this.searchParams.type = row.name;
      if (this.searchParams.type == "00") {
        this.getData({ status: this.searchParams.status });
      } else {
        this.getData({ status: this.searchParams.status, type: row.name });
      }
    },
    //获取数据
    getData (params) {
      this.$store.dispatch("setTableLoading", true);
      this.$axios
        .get("/api/v1/order", { params: params })
        .then(res => {
          if (res.data.status == "200") {
            let orders = res.data;
            this.paginum = orders.meta.current_page;
            this.dataList.data = orders.data;


            //获取页码数据
            this.pagination = orders.meta;

            this.listShow = true;
            //更新子组件
            this.updataChild = new Date().getTime();
            this.listWrapLoading = false;
            this.$store.dispatch("setTableLoading", false);
          } else {
            this.$popup(res.data.msg, "error");
          }
        })
        .catch(error => {
          // console.log(error);
        });
    },
    getSliderStatus (text) {
      switch (text) {
        case "待付款":
          return "1";
          break;
        case "待发货":
          return "2";
          break;
        case "待收货":
          return "3";
          break;
        case "退款中":
          return "4";
          break;
        case "交易完成":
          return "6";
          break;
        case "交易关闭":
          return "7";
          break;
        default:
          return "0";
          break;
      }
    }
  },
  components: {
    orderlist
  }
};
</script>
<style lang="less">
.height100 {
  position: relative;
  top: 0;
  bottom: 0;
  height: 100%;
}
.orderlist,
.orderlist-tabs {
  .height100;
}

.orderlist-tabs {
  padding-left: 24px;
  background-color: #ffffff;
  margin-bottom: 10px;
  &.orderlist-tabs-status .el-tabs__item.is-active:focus {
    color: #081234 !important;
  }
  .el-button:hover {
    color: #2e71fe;
  }
  .el-tabs__header {
    height: 52px;
    margin-bottom: 0;
    .el-tabs__nav-wrap,
    .el-tabs__nav-scroll,
    .el-tabs__nav,
    .el-tabs__item,
    .el-badge {
      height: 100%;
    }
    .el-tabs__nav-wrap::after {
      height: 0;
    }
    .el-tabs__active-bar {
      height: 4px;
      background-color: #2e71fe;
    }
    .el-tabs__item.is-active {
      color: #081234;
    }
    .el-tabs__item {
      line-height: 52px;
      span {
        display: inline-block;
        text-align: center;
      }
    }
    .el-badge__content.is-fixed {
      right: 4px;
      top: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/order-list.vue